.episodeNameColumn {
  width: 400px;
}

.episodeDescription {
  font-size: 12px;
}

.dateCell {
  min-width: 125px;
}

.showDetailsButton {
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
  color: var(--blue-700);
  cursor: pointer;
}

.showDetailsArrowIcon {
  width: 20px;
  margin-bottom: 2px;
}

.cover {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 4px;
}
